import permissions from "../../data/permissions" 
export default [
    {
        path: "users",
        name: "usersList",
        component: () => import("./../../views/administration/UsersListView.vue"),
        meta: { requiresAuth: true, authorization: permissions.user.read }

    },
    {
        path: `user/:id`,
        name: "UserDisplay",
        component: () => import("./../../views/administration/UserDisplayView.vue"),
        meta: { requiresAuth: true, authorization: permissions.user.read }
    },
    {
        path: 'user',
        name: 'User',
        component: () => import("./../../views/administration/UserCreateView.vue"),
        meta: { requiresAuth: true, authorization: permissions.user.create }
    },
    {
        path: 'user/:id/edit',
        name: 'UserEdit',
        component: () => import("./../../views/administration/UserEditView.vue"),
        meta: { requiresAuth: true, authorization: permissions.user.update }
    }
]